














import { Component, Vue } from "vue-property-decorator";

import { channelTypes } from "@/config/channels/channel-types.config.json";

@Component({})
export default class ChannelTypesTtabs extends Vue {
  activeChannelType = channelTypes[0];
  channelTypes = channelTypes;
}
